import React from 'react'
import css from './style.scss'

export default ({ children }) => (
  <h5 className={css.metricsSubTitle}>
    {children}
  </h5>
)
